export default "__VITE_ASSET__CUexMcKp__"